import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { RouterModule } from '@angular/router';
import { SaveStateData } from 'dbweb-core';
import { SetDeptComponent } from './set-dept.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatDialogModule,
		MatInputModule,
		MatFormFieldModule,
		MatButtonModule
	],
	declarations: [SetDeptComponent],
	entryComponents: [SetDeptComponent]
})
export class SetDeptModule {}
